"use client";

import {
  SESSION_STORAGE_KEY,
  useSessionStorage,
} from "@/components/hooks/use-session-storage";
import { useCallback } from "react";

export function useComebackUrl() {
  const sessionStorage = useSessionStorage();

  const setComebackUrl = useCallback(
    (comebackUrl: string) => {
      sessionStorage.setItem(SESSION_STORAGE_KEY.comebackUrl, comebackUrl);
    },
    [sessionStorage],
  );

  /**
   * ComebackUrlを取得する
   *
   * このメソッドが呼ばれると、値がセッションストレージから削除されることに注意して下さい。
   */
  const getComebackUrl = useCallback(() => {
    const comebackUrl = sessionStorage.getItem(SESSION_STORAGE_KEY.comebackUrl);
    // このsetTimeoutはreactStrictMode=trueでもcomebackUrlを取得するために必要です。
    setTimeout(() => {
      sessionStorage.removeItem(SESSION_STORAGE_KEY.comebackUrl);
    }, 0);
    return comebackUrl;
  }, [sessionStorage]);

  return { setComebackUrl, getComebackUrl };
}
